<script setup lang="ts">
import { h, resolveComponent } from "vue"
const DataStore = useDataStore()
const LangsStore = useLangsStore()

const UTextarea = resolveComponent("UTextarea")

// const resolver = ({ values }: unknown) => {
// 	const errors = { email: [], provider: [], customer: [] }

// 	if (!values.email) {
// 		errors.email.push({ type: 'required', message: 'Email is required.' })
// 	}

// 	if (!values.provider && !values.customer) {
// 		errors.provider.push({ type: 'required', message: 'One option is required.' })
// 	}

// 	if (!values.customer && !values.provider) {
// 		errors.customer.push({ type: 'required', message: 'One option is required.' })
// 	}

// 	console.log(errors)
// 	return {
// 		errors,
// 	}
// }

const lang_id = ref(LangsStore.context.lang_id)

// defineShortcuts({
// 	o: () => (open.value = !open.value),
// })
// const emit = defineEmits<{ close: [boolean] }>()
</script>

<template>
	<USelect
		v-model="lang_id"
		:allow-empty="false"
		color="primary"
		:items="LangsStore.langs_ids"
		highlight
		trailing-icon="i-lucide-globe"
		variant="outline"
		class="bg-transparent text-white"
		@change="LangsStore.changeLang(lang_id)"
		:ui="{
			placeholder: 'hidden',
		}"
	/>
</template>

<style lang="css"></style>
